<template>
  <div class="editor-controls">
    <GbButton
      v-if="!readOnly"
      :gbTheme="isEditMode ? 'greenPrimary' : 'bluePrimary'"
      size="xs"
      @click="$emit('toggle')"
      @mousedown.prevent
      :aria-label="isEditMode ? 'Save changes' : 'Edit text'"
      class="mr-1 w-16"
    >
      <span class="material-icons-round pr-1 text-lg">edit</span>
      {{ isEditMode ? 'Done' : 'Edit' }}
    </GbButton>
    <CopyButton
      :stringToCopy="textToCopy"
      tooltipText="Statement copied"
      buttonText="Copy"
      buttonTheme="grayOutlineSecondary"
      customClass="bg-white w-16"
      :autoHideTooltip="true"
      size="xs"
      iconClass="material-icons-outlined"
    />
  </div>
</template>

<script lang="ts">
import GbButton from '@/components/GbButton.vue'
import CopyButton from '@/components/CopyButton.vue'
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'WikiTextEditorControls',
  components: {
    GbButton,
    CopyButton
  },
  props: {
    isEditMode: {
      type: Boolean,
      required: true
    },
    textToCopy: {
      type: String,
      required: false,
      default: ''
    },
    readOnly: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  emits: ['toggle']
})
</script>
